import { lazyLoad } from './lazyload-init.js';

$(function() {

    var $devNbhMapContainer = $('#nbh-map-container');

    if ( $devNbhMapContainer.length ) {
        var $hotspotBtn = $devNbhMapContainer.find('.map-container button');
        var $hotspotContentContainer = $devNbhMapContainer.find('.content-container');
        var $hotspotContentPlaceholder = $devNbhMapContainer.find('.content-container .hotspot-content-placeholder');
        let lazyLoadInstance  = lazyLoad(); // Add lazyLoad

        $hotspotBtn.on('click', function() {
            var hotspotTarget = $(this).data('target');
            var $hotspotContent = $(hotspotTarget).clone();
            $hotspotContentContainer.addClass('hotspot-active');
            $hotspotContentPlaceholder.html($hotspotContent);
            lazyLoadInstance.update(); // Update LazyLoad
            // Init Tooltip - NOT WORKING
            /* $hotspotContentPlaceholder.tooltip({
                selector: '.has-tooltip',
                container: '.has-tooltip'
            }); */

        });
    }

});
